import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import clsx from "clsx";
import FileImport from "components/FileImport";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

const ImportFileModal = ({
  title,
  accepts,
  onOk,
  bodyText,
  okText,
  cancelText,
  className,
}) => {
  const dispatch = useDispatch();

  const [okButtonDisabled, setOkButtonDisabled] = useState(true);
  const [selectedFile, setSelectedFile] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!okButtonDisabled) {
      const formData = new FormData();
      formData.append("importedFile", selectedFile, selectedFile.name);

      onOk(formData, selectedFile.name);
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter" && !okButtonDisabled) {
      handleSubmit();
    }
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.IMPORT_FILE));
  };

  useEffect(() => {
    if (selectedFile && selectedFile.name.endsWith(accepts)) {
      setOkButtonDisabled(false);
      setError("");
    } else {
      setOkButtonDisabled(true);
      if (selectedFile) {
        setError(
          `You can only upload ${accepts.replace(
            ".",
            ""
          )} files. Please chose a file with the extension '${accepts}'`
        );
      }
    }
  }, [selectedFile]);

  return (
    <Modal
      data-testid="import-file-modal"
      className={clsx("fade-in", className)}
      show
      onDismiss={handleCancel}
      backdrop
      centered
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header>
        <b className="import_file_modal__header">{title}</b>
      </Modal.Header>
      <Modal.Body>
        <div className="import_file">
          <FileImport
            accepts={accepts}
            handleFileChange={handleFileChange}
            selectedFile={selectedFile}
            error={error}
            bodyText={bodyText}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={handleCancel}
        >
          {cancelText || "Cancel"}
        </NewButton>

        <NewButton
          data-testid="save-button"
          variant={NewButtonVariant.l1}
          onClick={handleSubmit}
          disabled={okButtonDisabled}
        >
          {okText || "Upload"}
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportFileModal;

ImportFileModal.propTypes = {
  title: PropTypes.string.isRequired,
  accepts: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
  bodyText: PropTypes.string,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  className: PropTypes.string,
};
